(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsNoClassificationController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService', '$rootScope', 'UserService'];

  function reports ($scope, $http, NotificationService, $rootScope, UserService) {
    var vm = this;

    $scope.vm = vm;

    vm.loading = false;

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      operator_id: '0'
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    if ($rootScope.checkMenuAccess('reports.noClassification.showAllUsers')) {
      UserService.findAll({
        id: $rootScope.user_data.company_id
      })
        .$promise
        .then(function (data) {
          vm.users = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $scope.labels.errorLoadUsers)
        })
    }

    vm.download = function (isSearch) {
      $http.get(apiUrl + '/reports/no_classification', {
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (isSearch) {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.error_message);
              return false;
            }
            var allTextLines = data.split(/\r\n|\n/);
            var headers = allTextLines[1].split(',');
            var header = [];
            for (var x = 0; x < headers.length; x++) {
              header.push(headers[x].replace(/["]/g, ''));
            }
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
              if (i > 1) {
                var data = allTextLines[i].split(',');
                if (data.length == header.length) {
                  var tarr = [];
                  for (var j = 0; j < header.length; j++) {
                    tarr.push(data[j].replace(/["]/g, ''));
                  }
                  lines.push(tarr);
                }
              }
            }
            vm.headers = header;
            vm.data = lines;
            vm.result = lines.length;
          } else {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.error_message);
              return false;
            }

            var filename = headers('Mktzap-Filename') || $scope.labels.reportName;

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' }); // Make sure it's not visible
            angular.element(document.body).append(anchor); // Attach to document

            var blob = new Blob([data], { type: 'text/csv' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove(); // Clean it up afterwards
            URL.revokeObjectURL(csvUrl); // Clean memory blob
          }
        }, function ({ data, status, headers, config }) {
          NotificationService.errorHandler(data, $scope.labels.errorReport);
        })
    };
  }
})();
